export type LiveMarketMenuKey = "premium-casion" | "tembo-casino" | "vip-casino";

export interface LiveMarketMenuConfig {
  key: LiveMarketMenuKey;
  title: string;
  groupId?: string;
}

export const LIVE_MARKET_MENUS: LiveMarketMenuConfig[] = [
  {
    key: "premium-casion",
    title: "Premium Casion",
    groupId:
      process.env.REACT_APP_LIVE_MARKET_PREMIUM_GROUP_ID ||
      process.env.REACT_APP_LIVE_MARKET_GROUP_ID,
  },
  {
    key: "tembo-casino",
    title: "Tembo Casino",
    groupId:
      process.env.REACT_APP_LIVE_MARKET_TEMBO_GROUP_ID ||
      process.env.REACT_APP_LIVE_MARKET_GROUP_ID,
  },
  {
    key: "vip-casino",
    title: "VIP Casino",
    groupId:
      process.env.REACT_APP_LIVE_MARKET_VIP_GROUP_ID ||
      process.env.REACT_APP_LIVE_MARKET_GROUP_ID,
  },
];

export const getLiveMarketMenuConfig = (key?: string): LiveMarketMenuConfig | undefined => {
  if (!key) return undefined;
  return LIVE_MARKET_MENUS.find((menu) => menu.key === key);
};
